"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var secp256k1_1 = require("secp256k1");

var abi_1 = require("../abi");

var buffer_1 = require("../buffer");

var crypto_1 = require("../crypto");

var ecdsa_1 = require("../ecdsa");

var constatnts_1 = require("./constatnts");

function toChecksumAddress(address) {
  address = address.toLowerCase();

  if (address.startsWith('0x')) {
    address = address.slice(2);
  }

  var hash = crypto_1.sha3(address).toString('hex');
  var chars = address.split('').map(function (char, index) {
    return parseInt(hash[index], 16) >= 8 ? char.toUpperCase() : char;
  });
  return "0x".concat(chars.join(''));
}

exports.toChecksumAddress = toChecksumAddress;

function bufferToAddress(buff) {
  return toChecksumAddress(buff.toString('hex'));
}

exports.bufferToAddress = bufferToAddress;

function computeCreate2Address(deployer, salt, byteCodeHash) {
  var codeHash = buffer_1.anyToBuffer(byteCodeHash);

  if (codeHash.length !== 32) {
    codeHash = crypto_1.sha3(codeHash);
  }

  var payload = abi_1.abiEncodePacked('bytes', 'address', 'bytes32', 'bytes')('0xff', deployer, salt, codeHash);
  return bufferToAddress(crypto_1.sha3(payload).slice(-20));
}

exports.computeCreate2Address = computeCreate2Address;

function verifyAddress(address) {
  var checksum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var result = false;

  if (address && /^(0x)?[0-9a-fA-F]{40}$/i.test(address) && address !== constatnts_1.ZERO_ADDRESS) {
    if (checksum) {
      result = address === toChecksumAddress(address);
    } else {
      result = true;
    }
  }

  return result;
}

exports.verifyAddress = verifyAddress;

function targetToAddress(target) {
  var result = null;

  switch (typeof target) {
    case 'string':
      result = target || null;
      break;

    case 'object':
      if (target && typeof target.address === 'string') {
        result = target.address || null;
      }

      break;
  }

  return result;
}

exports.targetToAddress = targetToAddress;

function convertAddress(address) {
  var result = null;
  var buff = buffer_1.anyToBuffer(address);

  if (buff && buff.length === 20) {
    result = bufferToAddress(buff);
  }

  return result;
}

exports.convertAddress = convertAddress;

function publicKeyToAddress(publicKey) {
  var result = null;

  try {
    publicKey = secp256k1_1.publicKeyConvert(publicKey, false);

    if (ecdsa_1.verifyPublicKey(publicKey)) {
      result = bufferToAddress(crypto_1.sha3(publicKey.slice(1)).slice(-20));
    }
  } catch (err) {
    result = null;
  }

  return result;
}

exports.publicKeyToAddress = publicKeyToAddress;

function privateKeyToAddress(privateKey) {
  var result = null;

  try {
    var publicKey = ecdsa_1.privateToPublicKey(privateKey);

    if (publicKey) {
      result = publicKeyToAddress(publicKey);
    }
  } catch (err) {
    result = null;
  }

  return result;
}

exports.privateKeyToAddress = privateKeyToAddress;